import { DataGrid, Form, Lookup, RadioGroup, TagBox } from 'devextreme-react';
import './ConfigReportes.scss';
import { Column, Item, LoadPanel, Paging, SearchPanel, Toolbar, Button, Editing } from 'devextreme-react/data-grid';
import { useCallback, useEffect, useRef, useState } from 'react';
import CustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
import { ReportTypeList } from '../../types/types.reports';
import { useApiConfiguration } from '../../api/api.configuration';
import { XmlFile } from '../../images/icons';
import { FormPopup, newToast } from '../../components';
import LoadPnl from 'devextreme-react/load-panel';
import { Button as ButtonItem } from 'devextreme-react';
import { Item as ItemF, Label } from 'devextreme-react/form';
import { useAppSelector } from '../../contexts/hooks';

const currentFilters = {
  downloadType: undefined,
};

const priorityEntities = [
  { label: 'Completo', value: 1 },
  { label: 'Solo reporte', value: 2 },
];

const Index = () => {
  const gridRef = useRef<DataGrid>(null);
  const { getReports, updateReport, newReport } = useApiConfiguration();
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [selectedItem, setSelectedItem] = useState<any>(null);
  const [modalvisible, setModalVisible] = useState(false);
  const [modalPermissions, setModalPermissions] = useState(false);
  const [selectedPermissions, setSelectedPermissions] = useState<number[]>([]);
  const lstUsuariosPerfiles = useAppSelector((x) => x.configuration.Data?.UsuariosPerfiles)?.filter((x) => x.Pe_Estado && x.Pe_Id !== 2);
  const customDataSrc = new CustomStore({
    key: 'Rp_Id',
    load: () =>
      Promise.resolve({
        data: data,
        totalCount: 0,
      }),
    remove: (key) => {
      return new Promise((resolve) => {
        resolve();
      });
    },
  });

  const fetchData = () => {
    getReports().then((res) => {
      setData(res);
    });
  };

  useEffect(() => {
    fetchData();
  }, []);

  const customData = new DataSource({
    store: customDataSrc,
    reshapeOnPush: true,
  });

  const handleLoadXml = (e: any) => {
    if (e.row.data.Rp_Tipo === 4) {
      newToast('WARNING', 'No se puede cargar el xml en este tipo de reporte', 5);
      return;
    }
    //Abrir el administrador de a archivos para que el usuario seleccione el archivo xml, luego dejarlo en una variable para luego enviarlo al servidor
    const fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.accept = '.xml';
    fileInput.onchange = (event) => {
      const file = (event.target as HTMLInputElement).files?.[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = () => {
          setLoading(true);
          const xmlContent = reader.result;
          // Aquí puedes enviar el contenido XML al servidor o procesarlo como desees
          const data = {
            ...e.row.data,
            Rp_Reporte: xmlContent,
          };
          console.log('data:', data);
          updateReport(e.row.data.Rp_Id, data)
            .then((res) => {
              if (res) {
                fetchData();
              }
            })
            .finally(() => {
              setLoading(false);
            });
        };
        reader.readAsText(file);
      }
    };
    fileInput.click();
  };

  const handleDownLoad = (e: any) => {
    if (e.row.data.Rp_Tipo === 4) {
      newToast('WARNING', 'No es posible descargar reportes tipo tableros de control', 5);
      return;
    }
    setSelectedItem(e.row.data);
    setModalVisible(true);
  };

  const handlePermissions = (e: any) => {
    const { Rp_Id, Rp_Nombre } = e.row.data;
    console.log('Rp_Id:', e.row.data);
    setSelectedItem(e.row.data);
    
    // Inicializar selectedPermissions basado en Rp_Permisos
    if (e.row.data.Rp_Permisos === '-1') {
      // Si es -1, seleccionar todos los perfiles
      setSelectedPermissions(lstUsuariosPerfiles?.map((x) => x.Pe_Id) || []);
    } else if (typeof e.row.data.Rp_Permisos === 'string' && e.row.data.Rp_Permisos) {
      // Si es una cadena con IDs separados por comas
      setSelectedPermissions(e.row.data.Rp_Permisos.split(',').map((id) => parseInt(id.trim())).filter((id) => !isNaN(id)));
    } else {
      // Por defecto, ningún permiso seleccionado
      setSelectedPermissions([]);
    }
    
    setModalPermissions(true);
  };

  const loadReport = useCallback(() => {
    const fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.accept = '.json';
    fileInput.onchange = (event) => {
      const file = (event.target as HTMLInputElement).files?.[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = () => {
          const jsonContent = reader.result;
          const data = JSON.parse(jsonContent as string);
          delete data.Rp_Id; // Eliminar el id para que no se envíe al servidor
          if (data.Rp_Tipo === 5 || data.Rp_Tipo === 1) {
            newToast('WARNING', 'No es posible cargar reportes del sistema ni tableros de control', 5);
            return;
          }
          setLoading(true);
          newReport(data)
            .then((res) => {
              if (res) {
                fetchData();
              }
            })
            .finally(() => {
              setLoading(false);
            });
        };
        reader.readAsText(file);
      }
    };
    fileInput.click();
  }, []);

  const handleCloseModal = useCallback(() => {
    setModalVisible(false);
  }, [setModalVisible]);

  const handleCloseModalPermissions = useCallback(() => {
    setModalPermissions(false);
    setSelectedPermissions([]);
  }, [setModalPermissions]);

  const handleSavePermissions = useCallback(() => {
    alert('Guardando permisos...');
    if (!selectedItem) return;
    
    // Si no hay permisos seleccionados, enviar "-1" (todos tienen acceso)
    // Si hay permisos seleccionados, enviar los IDs separados por comas
    const newPermissions = selectedPermissions.length === 0 ? '-1' : selectedPermissions.join(',');
    const updatedItem = { ...selectedItem, Rp_Permisos: newPermissions };
    
    setLoading(true);
    alert('Permisos actualizados: ' + newPermissions);
    updateReport(selectedItem.Rp_Id, updatedItem)
      .then((res) => {
        if (res) {
          fetchData();
          setModalPermissions(false);
          setSelectedPermissions([]);
          newToast('SUCCESS', 'Permisos actualizados correctamente', 3);
        }
      })
      .catch(() => {
        newToast('ERROR', 'Error al actualizar los permisos', 5);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [selectedItem, selectedPermissions, updateReport, fetchData]);

  const handleClicApply = useCallback(() => {
    if (!currentFilters.downloadType) {
      newToast('WARNING', 'Seleccione el tipo de descarga', 5);
      return;
    }
    setModalVisible(false);
    // Aquí puedes manejar la lógica de aplicar los cambios
    if (currentFilters.downloadType === 1) {
      const blob = new Blob([JSON.stringify(selectedItem)], { type: 'text/json' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${selectedItem.Rp_Nombre}.json`;
      a.click();
      URL.revokeObjectURL(url);
      return;
    }

    if (currentFilters.downloadType === 2) {
      const blob = new Blob([selectedItem.Rp_Reporte], { type: 'text/xml' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${selectedItem.Rp_Nombre}.xml`;
      a.click();
      URL.revokeObjectURL(url);
    }
  }, [currentFilters, selectedItem]);

  return (
    <div className={'view crm-contact-list'}>
      <LoadPnl className='load-panel' visible={loading} showIndicator={true} showPane={true} shadingColor={'rgba(0,0,0,0.4)'} />
      <div className={'view-wrapper view-wrapper-contact-list'}>
        <DataGrid className='grid' dataSource={customData} ref={gridRef} height='100%' repaintChangesOnly={true} highlightChanges={false} rowAlternationEnabled={true} showColumnLines={true}>
          <LoadPanel enabled={true} />
          <Editing allowUpdating={true} allowDeleting={false} mode='cell' />
          <SearchPanel visible placeholder='Buscar' />
          <Paging enabled={false} />
          <Toolbar>
            <Item location='before'>
              <div className='grid-header'>Reportes del sistema</div>
            </Item>
            <Item>
              <ButtonItem icon='refresh' onClick={fetchData} hint='Actualizar' />
            </Item>
            <Item>
              <ButtonItem icon='upload' onClick={loadReport} hint='Cargar reporte' />
            </Item>
            <Item name='searchPanel' locateInMenu='auto' />
          </Toolbar>
          <Column dataField='Rp_Nombre' caption='REPORTE' />
          <Column dataField='Rp_Tipo' caption='TIPO' cellRender={handleRenderTipo} width={150} alignment='center' />
          <Column type='buttons' caption='ACCIONES' width={110} alignment='center'>
            <Button hint='Cargar xml' icon={XmlFile} onClick={handleLoadXml} />
            <Button hint='Descargar reporte' icon='download' onClick={handleDownLoad} />
            <Button hint='Descargar reporte' icon='imgarlock' onClick={handlePermissions} />
          </Column>
        </DataGrid>
      </div>
      <FormPopup title='Tipo de descarga' visible={modalvisible} setVisible={handleCloseModal} onSave={handleClicApply} width={400} loading={false} allowSave={false}>
        <Form validationGroup='ValidationForm' formData={currentFilters} labelLocation='left' className='plain-styled-form'>
          <ItemF isRequired dataField='downloadType' editorType='dxRadioGroup' editorOptions={{ items: priorityEntities, valueExpr: 'value', displayExpr: 'label', layout: 'horizontal' }}>
            <Label text=' ' />
          </ItemF>
        </Form>
      </FormPopup>

      <FormPopup title='Permisos del reporte' visible={modalPermissions} setVisible={handleCloseModalPermissions} onSave={handleSavePermissions} width={500} loading={loading} allowSave={false}>
        <div style={{ padding: '10px 0' }}>
          <p style={{ marginBottom: '15px', color: '#666' }}>
            Seleccione los perfiles que tendrán acceso a este reporte. Si no selecciona ninguno, todos los perfiles tendrán acceso.
          </p>
          <TagBox
            dataSource={lstUsuariosPerfiles}
            valueExpr='Pe_Id'
            displayExpr='Pe_Nombre'
            showSelectionControls={true}
            applyValueMode='useButtons'
            searchEnabled={true}
            multiline={true}
            placeholder='Seleccione los perfiles con acceso'
            value={selectedPermissions}
            onValueChanged={(e) => {
              setSelectedPermissions(e.value || []);
            }}
          />
        </div>
      </FormPopup>
    </div>
  );
};

const handleRenderTipo = (e: any) => {
  const tipo = e.value;
  const text = ReportTypeList.find((item) => item.value === tipo)?.label || 'Desconocido';
  return <span>{text}</span>;
};

export default Index;
